class Pinned {
    constructor(element) {
        this.el = element;

        this.init();
    }

    init() {
        window.addEventListener("scroll", this.handlePinning.bind(this));
    }

    handlePinning() {
        const position_from_top = this.el.getBoundingClientRect().top;

        if (position_from_top <= 0) {
            this.el.classList.add("is-pinned");
        } else {
            this.el.classList.remove("is-pinned");
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    if (window.matchMedia("(min-width: 64em)").matches) {
        const element = document.querySelector(".page-header__sticky");
        if (element) new Pinned(element);
    }
});
